import { QUEUE_STATUS } from './types';
import _ from "lodash";

export const setQueueStatusDefault = () => {
    return {
        type: QUEUE_STATUS.SET_QUEUE_STATUS_DEFAULT,
    }
}

export const setQueueStatus = (queueStatus) => {
    return {
        type: QUEUE_STATUS.SET_QUEUE_STATUS,
        queueStatus: queueStatus
    }
}

export const setQueueStatusValue = (draftType, orignalProduct, key, value, index) => {
    const queueStatus = _.cloneDeep(orignalProduct);
    switch (draftType) {
        default:
            queueStatus[draftType] = value;
    }
    return {
        type: QUEUE_STATUS.SET_QUEUE_STATUS_VALUE,
        queueStatus: queueStatus
    }
}

export const setQueueStatusResourcesStepsValue = (draftType, orignalProduct, key, value, index) => {

    const queueStatus = _.cloneDeep(orignalProduct);

    switch (draftType) {
        default:
            queueStatus.resourcesSteps[index] = value;
    }
    return {
        type: QUEUE_STATUS.SET_QUEUE_STATUS_VALUE,
        queueStatus: queueStatus
    }
}